<template>
  <v-flex xs12 pt-0 mt-1>
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap v-bind:class="{ gray: isCanceled }">
            <v-flex xs12 lg9 py-0>
              <v-layout row wrap>
                <v-flex xs12 py-0>
                  {{insertedDate}} - ID <em>{{record.id}}</em>
                </v-flex>
                <v-flex xs12 py-0>
                  <b>{{record.subject.social_name.toUpperCase()}}</b> ({{record.subject.document_type.toUpperCase()}} {{mask(record.subject.document_type, record.subject.document_number)}})
                </v-flex>
                <v-flex xs12 py-0>
                  <h3 style="display: inline" v-bind:class="{ linethrough: isCanceled }">{{transactionValueStr}}</h3> ({{record.status}}) <span class="alert" v-if="!record.cleared">(Requer aprovação de cadastro)</span>
                </v-flex>
                <v-flex xs12 py-0>
                  <b>De:</b> {{fromBankAccountOrCreditCard}}
                </v-flex>
                <v-flex xs12 py-0>
                  <b>Para:</b> {{toBankAccount}}
                </v-flex>
                <v-flex xs12 py-0>
                  <span v-if="isForExchange && !isDepositToInternalAccount && !isFromInternalAccount"><b>{{record.company.social_name}}</b> solicitando conversão {{record.exchange_currency}}</span>
                  <span v-if="isForExchange && !isDepositToInternalAccount && isFromInternalAccount"><b>{{record.company.social_name}}</b> solicita conversão a partir de saldo em conta interna</span>
                  <span v-if="isForExchange && isDepositToInternalAccount && !isFromInternalAccount"><b>{{record.company.social_name}}</b> solicita conversão para conta interna</span>
                  <span v-if="isForExchange && isDepositToInternalAccount && isFromInternalAccount"><b>{{record.company.social_name}}</b> solicita conversão a partir de saldo em conta interna para conta interna</span>
                  <span v-if="!isForExchange && !isDepositToInternalAccount && !isFromInternalAccount"><b>{{record.company.social_name}}</b> solicitando transferência entre contas físicas sem conversão</span>
                  <span v-if="!isForExchange && !isDepositToInternalAccount && isFromInternalAccount"><b>{{record.company.social_name}}</b> solicitando pagamento a partir de saldo em conta interna sem conversão</span>
                  <span v-if="!isForExchange && isDepositToInternalAccount && !isFromInternalAccount"><b>{{record.company.social_name}}</b> solicitando depósito em conta interna sem conversão</span>
                  <span v-if="!isForExchange && isDepositToInternalAccount && isFromInternalAccount"><b>{{record.company.social_name}}</b> solicita transferência entre contas internas sem conversão</span>
                  <span v-if="!isForExchange && isDepositToInternalAccount && isFromInternalAccount"><b>{{record.company.social_name}}</b> solicita transferência entre contas internas sem conversão</span>
                </v-flex>

                <v-flex xs12 py-0 v-if="isCanceled">
                  <b>{{i18n('Razão do Cancelamento')}}: </b> {{canceledReason}}
                </v-flex>
                <v-flex xs12 py-0 v-if="changeRequestedByCustomer">
                  <b :title="i18n('Cambio solicitado pelo cliente')">{{i18n('Cambio Solicitado')}}: </b> {{exchangeUnderRequest}}
                </v-flex>
                <v-flex xs12 py-0 v-if="reverseExchange">
                  <b>{{i18n('Cambio Reverso')}}: </b> {{estimatedValueUntilExchange}}
                </v-flex>

                <v-flex xs12 py-0 v-if="bankTransactionId">
                  <b>Transação bancária: </b> {{bankTransactionId}}
                </v-flex>
                <v-flex xs12 py-0 v-if="bankTransactionId && record.bank_transaction.exchange_id">
                  <b>Operação de Cãmbio: </b> {{record.bank_transaction.exchange_id}}
                </v-flex>

                <!-- Company Wire -->
                <v-flex xs12 py-0 v-if="isWired">
                  <b>{{i18n('Company Wire Id')}}: </b> {{getCompanyWireId}}
                </v-flex>

                <!-- Pix QR Code -->
                <v-flex xs12 py-0 v-if="showDynamicPixQrcode && !isGlobalPix">
                  <span style="cursor: pointer; text-decoration: underline; color: #27dabc" class="pix_qrcode nowrap font-size-10" @click.stop="showQRCode">
                    Pix QR Code
                  </span>
                  <qrcode-vue class="qrcode_image" :value="dynamicPixQrcode" :size="150" level="H" style="margin-top: 10px;"/>
                </v-flex>

                <!-- Dynamic Pix -->
                <v-flex xs12 py-0 v-if="record.dynamic_pix">
                  <v-flex xs02 lg3>
                    <b>{{i18n('Pix Dinamico')}}:</b> {{dynamicPix}}
                  </v-flex>
                  <v-flex xs06 lg5 v-if="dynamicPixDueDate">
                    <b>{{i18n('Data de expiração pix')}}:</b> {{dynamicPixDueDate}}
                  </v-flex>
                </v-flex>

                <!-- Global Pix -->
                <v-flex xs12 py-0 v-if="isGlobalPix">
                  <v-flex xs04 lg4>
                    <span style="cursor: pointer; text-decoration: underline; color: #27dabc" class="nowrap font-size-10" @click.stop="showQRCode">
                      Global pix
                    </span>
                    <qrcode-vue class="qrcode_image" :value="dynamicPixQrcode" :size="150" level="H" style="margin-top: 10px;"/>
                  </v-flex>
                </v-flex>

                <!-- Boleto -->
                <v-flex xs12 py-0 v-if="isBoleto">
                  <span style="cursor: pointer; text-decoration: underline; color: #27dabc" class="nowrap font-size-10" @click.stop="showBoleto">
                    Boleto
                  </span>
                  <v-flex class="boleto_infos" >
                    <v-flex xs12>
                      <b>Código de Barras: </b> {{this.record.boleto_info.bar_code}}
                    </v-flex>
                    <v-flex xs12>
                      <b>Linha Digital: </b> {{this.record.boleto_info.digital_line}}
                    </v-flex>
                    <v-flex xs12>
                      <b>URL do PDF: </b> {{this.record.boleto_info.url_pdf}}
                    </v-flex>
                    <v-flex xs12>
                      <b>Data de Expiração: </b> {{this.record.boleto_info.expire_at}}
                    </v-flex>
                  </v-flex>
                </v-flex>

                <!-- Oxxo -->
                <v-flex xs12 py-0 v-if="isOxxo">
                  <span style="cursor: pointer; text-decoration: underline; color: #27dabc" class="nowrap font-size-10" @click.stop="showOxxo">
                    Oxxo
                  </span>
                  <v-flex class="oxxo_infos" >
                    <v-flex xs12 lg12>
                      <b>Valor: </b> {{this.record.oxxo_info.amount}}
                    </v-flex>
                    <v-flex xs12 lg12>
                      <b>Descrição: </b> {{this.record.oxxo_info.description}}
                    </v-flex>
                    <v-flex xs12 lg12>
                      <b>URL do PDF: </b> {{this.record.oxxo_info.url_pdf}}
                    </v-flex>
                    <v-flex xs12 lg12>
                      <b>Data de Expiração: </b> {{this.record.oxxo_info.expire_at}}
                    </v-flex>
                  </v-flex>
                </v-flex>

                <!-- PSE -->
                <v-flex xs12 py-0 v-if="isPse">
                  <span style="cursor: pointer; text-decoration: underline; color: #27dabc" class="nowrap font-size-10" @click.stop="showPse">
                    PSE
                  </span>
                  <v-flex class="pse_infos" >
                    <v-flex xs12 lg12>
                      <b>Ticket ID: </b> {{this.record.pse_info.ticket_id}}
                    </v-flex>
                    <v-flex xs12 lg12>
                      <b>Código Único Sequencial: </b> {{this.record.pse_info.trazability_code}}
                    </v-flex>
                    <v-flex xs12 lg12>
                      <b>ID de autorização: </b> {{this.record.pse_info.authorization_id}}
                    </v-flex>
                    <v-flex xs12 lg12>
                      <b>Código do banco: </b> {{this.record.pse_info.financial_institution_code}}
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 lg3 py-0>
              <v-btn v-if="shouldExpectBankTransaction" slot="btn" block dark class="ma-0 btn-style--secondary mt-3" @click.stop="addBankTransaction">
                <v-icon left>paid</v-icon>
                Cadastrar Transação Bancária
              </v-btn>
              <template>
                  <v-btn v-if="record.status !== 'canceled'" block dark class="ma-0 secondary-btn-bg-color mt-3" @click.stop="showCancelView">
                    <v-icon left>cancel</v-icon>
                    Cancelar Transação
                  </v-btn>
                  <v-flex v-if="isCancelTransactionVisible" class="mt-3">
                    <v-textarea  label="Razão para o cancelamento" outlined v-model="cancelReason" rows="1" class="mt-3"></v-textarea>
                    <span v-if="cancelError" class="error-message">
                      {{ cancelError }}
                    </span>
                    <v-layout row wrap class="mt-3">
                      <v-btn class="btn-style--gray mr-2" block dark @click="toggleTransactionView">
                        Fechar
                      </v-btn>
                      <v-btn block color="#27DABC" style="color: white;" class="btn-style--secondary" @click.stop="showCancelDialog = true" :disabled="!cancelReason">
                        Confirmar
                      </v-btn>
                    </v-layout>
                  </v-flex>
                  <v-dialog v-model="showCancelDialog" max-width="400">
                    <v-card>
                      <v-card-title class="headline">
                        Confirmar Cancelamento
                      </v-card-title>
                      <v-card-text>
                        Tem certeza que deseja cancelar esta transação?
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="showCancelDialog = false">
                          Não
                        </v-btn>
                        <v-btn color="#27DABC" text @click="confirmCancelTransaction">
                          Sim, cancelar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
              </template>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>

<script>
import utils from "./shared/Utils"
import QrcodeVue from "qrcode.vue"

export default {
  name: 'ScheduledBankTransactionItem',
  components: {
    QrcodeVue,
  },
  props: {
    record: {
      type: Object
    }
  },
  data() {
    return {
      current_view: 'short',
      qrcode_string: "",
      isCancelTransactionVisible: false,
      cancelReason: "",
      cancelError: "",
      showCancelDialog: false
    }
  },
  computed: {
    insertedDate() {
      return utils.dbDateTimeToHuman(this.record.inserted_at)
    },
    fromBankAccountOrCreditCard() {
      if (this.record.from_bank_account) {
        return `${utils.longAccountName(this.record.from_bank_account)} (ID ${this.record.from_bank_account.id.split('-')[0]})`
      }
      return 'Cartão de crédito'
    },
    shouldExpectBankTransaction() {
      return this.record.status != 'canceled' && this.record.from_bank_account && !this.isFromInternalAccount && !this.bankTransactionId
    },
    toBankAccount() {
      return `${utils.longAccountName(this.record.to_bank_account)} (ID ${this.record.to_bank_account.id.split('-')[0]})`
    },
    exchangeUnderRequest() {
      return this.convertBooleanToYesOrNo(this.record.exchange_under_request)
    },
    estimatedValueUntilExchange() {
      return this.convertBooleanToYesOrNo(this.record.estimated_value_until_exchange)
    },
    dynamicPix() {
      return this.convertBooleanToYesOrNo(this.record.dynamic_pix)
    },
    dynamicPixQrcode() {
      return this.record.dynamic_pix_qr_code
    },
    showDynamicPixQrcode() {
      return this.record.dynamic_pix_qr_code ? true : false
    },
    dynamicPixDueDate() {
      return this.record.dynamic_pix_due_date
    },
    canceledReason() {
      return this.record.canceled_reason
    },
    isGlobalPix() {
      return this.record.transaction_kind == 1
    },
    isBoleto() {
      return this.record.payment_method == 1
    },
    isOxxo() {
      return this.record.payment_method == 2
    },
    isPse() {
      return this.record.payment_method == 4
    },
    getCompanyWireId() {
      return this.record.bank_transaction.wire_id
    },
    isDynamicPix() {
      return this.record.dynamic_pix
    },
    isForExchange() {
      return !(this.record.for_exchange === false)
    },
    isFromInternalAccount() {
      return this.record.from_bank_account && this.record.from_bank_account.internal === true
    },
    isDepositToInternalAccount() {
      return this.record.to_bank_account && this.record.to_bank_account.internal === true
    },
    transactionValueStr() {
      if (this.isReverseExchange) {
        if (this.record.value) {
          return `${this.l(this.record.value, this.record.currency)} -> ${this.l(this.record.exchanged_value, this.record.exchange_currency)}`
        }
        return `${this.record.currency} -> ${this.l(this.record.exchanged_value, this.record.exchange_currency)}`
      }
      if (this.record.exchanged_value) {
        return `${this.l(this.record.value, this.record.currency)} -> ${this.l(this.record.exchanged_value, this.record.exchange_currency)}`
      }
      return `${this.l(this.record.value, this.record.currency)} -> ${this.record.exchange_currency}`
    },
    isReverseExchange() {
      return !!this.record.estimated_value_until_exchange
    },
    isCanceled() {
      return this.record.status == 'canceled'
    },
    changeRequestedByCustomer() {
      return this.record.exchange_under_request
    },
    reverseExchange() {
      return this.record.estimated_value_until_exchange
    },
    isWired() {
      return this.record.status == 'wired'
    },
    bankTransactionId() {
      return this.record.bank_transaction_id || (this.record.bank_transaction && this.record.bank_transaction.id)
    }
  },
  methods: {
    addBankTransaction() {
      this.$emit('onAddBankTransaction', this.record)
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    mask(format, value) {
      return utils.mask(format, value)
    },
    convertBooleanToYesOrNo(boolean_value) {
      return boolean_value ? this.i18n("Sim") : this.i18n("Não")
    },
    showQRCode: function(event) {
      event.target.classList.toggle("active");
      var qr_code_image = event.target.nextElementSibling;
      if (qr_code_image.style.display === "block") {
        qr_code_image.style.display = "none";
      } else {
        qr_code_image.style.display = "block";
      }
    },
    showBoleto: function(event) {
      event.target.classList.toggle("active");
      var boleto_infos = event.target.nextElementSibling;
      if (boleto_infos.style.display === "block") {
        boleto_infos.style.display = "none";
      } else {
        boleto_infos.style.display = "block";
      }
    },
    showOxxo: function(event) {
      event.target.classList.toggle("active");
      var oxxo_infos = event.target.nextElementSibling;
      if (oxxo_infos.style.display === "block") {
        oxxo_infos.style.display = "none";
      } else {
        oxxo_infos.style.display = "block";
      }
    },
    showPse: function(event) {
      event.target.classList.toggle("active");
      var pse_infos = event.target.nextElementSibling;
      if (pse_infos.style.display === "block") {
        pse_infos.style.display = "none";
      } else {
        pse_infos.style.display = "block";
      }
    },
    i18n(str) {
      return this.$root.l(str)
    },
    showCancelView() {
      this.isCancelTransactionVisible = true;
      this.cancelReason = "";
      this.cancelError = "";
    },

    toggleTransactionView() {
      this.isCancelTransactionVisible = !this.isCancelTransactionVisible;
    },

    confirmCancelTransaction() {
    this.showCancelDialog = false;
    this.submitCancelTransaction();
    },

    async submitCancelTransaction() {
    const payload = { reason: this.cancelReason };

    const successCallback = () => {
        this.isCancelTransactionVisible = false;
        this.cancelReason = "";
        this.cancelError = "";
        this.$emit("onRemoveTransaction", this.record.id);
      };

    const errorCallback = (response) => {
      console.error("Erro ao realizar cancelamento", response);

      let errorMessage = "Erro ao cancelar a transação.";

    if (response.bodyText) {
      const errorData = JSON.parse(response.bodyText);
      errorMessage = Object.entries(errorData.errors)
      .map(([key, message]) => `Ação Indisponível: ${this.i18n(message)}`)
      .join("; ");
    } else {
    errorMessage = "Erro desconhecido ao cancelar a transação.";
    }

    this.cancelError = errorMessage;
    this.isCancelTransactionVisible = true;
    };

    const token = this.$cookies.get("api_token");

    this.$http
      .post(
        this.$root.urls.admin__bank_transactions_cancel.replace("ID", this.record.id),
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(successCallback, errorCallback);
    }
  },
  mounted() {
  }
}
</script>

<style>
.alert { color: red; }
.gray { color: #666; }
.linethrough { text-decoration: line-through; }

.qrcode_image,
.boleto_infos,
.oxxo_infos,
.pse_infos {
  display: none;
}

.error-message {
    color: red;
    font-size: 0.9rem;
    margin-top: 4px;
  }

.secondary-btn-bg-color{
  color: var(--background-color)!important;
  background-color: rgba(0,0,0,.10)!important;
  height: 56px;
}

</style>



// WEBPACK FOOTER //
// src/ScheduledBankTransactionItem.vue